import { Box, Container, Link } from '@utilitywarehouse/hearth-react';
import UWLogoWhite from '@utilitywarehouse/hearth-svg-assets/lib/logo-full-warm-white.svg';

export const Navbar: React.FC = () => {
  return (
    <Container padding="250" backgroundColor='brand'>
      <Box width="fit-content">
        <Link href="https://uw.co.uk/">
          <img src={UWLogoWhite} alt="Utility Warehouse Logo" />
        </Link>
      </Box>
    </Container>
  );
};
